var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12ZM4.3125 5.95312C3 7.64062 2.25 9.75 2.25 12C2.25 17.3906 6.60938 21.75 12 21.75C14.25 21.75 16.3594 21 18.0469 19.6875L4.3125 5.95312ZM21.75 12C21.75 6.65625 17.3438 2.25 12 2.25C9.70312 2.25 7.59375 3.04688 5.90625 4.35938L19.6406 18.0938C20.9531 16.4062 21.75 14.2969 21.75 12Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelClass);
export default __webpack_public_path__ + "static/media/cancelClass.c41a83ce70087b5d389a12c4142bc783.svg";
export { ForwardRef as ReactComponent };